module.exports = __webpack_public_path__ + "static/media/circle.1e2d0595.svg";